import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/th";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import { DEFAULT_LANGUAGE, type Language } from "@/i18n/resolve-language";

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.locale(DEFAULT_LANGUAGE);

/** Keep dayjs's global locale in step with the UI language. */
export function setDayjsLocale(lng: Language): void {
  dayjs.locale(lng);
}

export { dayjs };
